document.addEventListener('DOMContentLoaded', () => {
 const LIMIT = 10;

 function getQuantityInput() {
  return document.querySelector(
   'quantity-selector-component input[name="quantity"]'
  );
 }

 function updateState() {
  const input = getQuantityInput();
  if (!input) return;

  const qty = parseInt(input.value, 10) || 1;

  if (qty > LIMIT) {
   document.documentElement.classList.add('quantity-limit-exceeded');
  } else {
   document.documentElement.classList.remove('quantity-limit-exceeded');
  }
 }

 // Detectar + / -
 document.addEventListener('click', (e) => {
  if (e.target.closest('quantity-selector-component')) {
   setTimeout(updateState, 120);
  }
 });

 // Escritura manual
 document.addEventListener('input', (e) => {
  if (e.target.matches('input[name="quantity"]')) {
   setTimeout(updateState, 50);
  }
 });

 // Inicial
 setTimeout(updateState, 150);
});
